import React from 'react';
import { motion } from 'framer-motion';
import { Globe, Users, Star, Award } from 'lucide-react';

const Stats = () => {
  const stats = [
    { label: 'Destinations', value: '50+', icon: Globe },
    { label: 'Happy Travelers', value: '10k+', icon: Users },
    { label: 'Years Experience', value: '25', icon: Award },
    { label: 'Average Rating', value: '4.9', icon: Star },
  ];

  return (
    <section className="py-20 bg-slate-900 text-white">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-12">
          {stats.map((stat, idx) => (
            <motion.div
              key={stat.label}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-40px' }}
              transition={{ delay: idx * 0.12, type: 'spring', stiffness: 120, damping: 18 }}
              className="text-center space-y-4"
            >
              <div className="w-16 h-16 mx-auto bg-orange-500/20 rounded-2xl flex items-center justify-center text-orange-500">
                <stat.icon size={32} />
              </div>
              <div className="space-y-1">
                <h3 className="text-4xl font-serif font-bold tracking-tight">{stat.value}</h3>
                <p className="text-slate-400 font-black uppercase tracking-widest text-[10px]">{stat.label}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stats;
